export default __webpack_public_path__ + "static/media/BrainBreak cards84.449d4e88.png";